// MAIN FORMULAS
//
// Light speed = 0.299792458 [m/ns]
// speedC = v/c
//
// Length contraction: L = L0 * sqrt(1 - (v/c)^2)
//                     L = L0 * sqrt(1 - speedC^2)
//
// Length enlargement: L0 = L / sqrt(1 - (v/c)^2)
//                     L0 = L / sqrt(1 - speedC^2)
//
// Time dilation: T = T0 * sqrt(1 - (v/c)^2)
//                T = T0 * sqrt(1 - speedC^2)
//
// Synchronizing Clocks: clockTime = middleClockTime - clockPos * V/c^2
//                       clockTime = middleClockTime - clockPos * speedC/c
//
// Travel time: T = distance / v
//              T = distance / (speedC * c)
//

const LIGHT_SPEED = 0.299792458

export function lengthContraction (length0, speedC) {
  let length = length0 * Math.sqrt(1 - Math.pow(speedC, 2))
  return length
}

export function lengthEnlargement (length, speedC) {
  let length0 = length / Math.sqrt(1 - Math.pow(speedC, 2))
  return length0
}

export function timeDilation (time0, speedC) {
  let time = time0 * Math.sqrt(1 - Math.pow(speedC, 2))
  return time
}

export function remoteClockTime (clockPos, timeClock0, speedC) {
  let timeClock = timeClock0 - clockPos * speedC / LIGHT_SPEED
  return timeClock
}

export function travelTime (distance, speedC) {
  let travelTime = distance / (speedC * LIGHT_SPEED)
  return travelTime
}
